// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';

/**
 * Checks whether the recipe has conditions
 *
 * @return {Boolean} True if the recipe has conditions
 */
const recipeHasConditions = () => {
	return ! isEmpty( UncannyAutomator.recipe.conditions );
};

export default recipeHasConditions;
